<mat-form-field
  class="ignite-auto-complete-field"
  [attr.id]="id"
  [hideRequiredMarker]="true"
  appearance="outline"
  [class.is-empty]="isEmpty()"
  >
  @if (label !== '') {
    <mat-label floatLabel>{{ label }}</mat-label>
  }
  <input
    matInput
    [formControl]="frmCtrl"
    [matAutocomplete]="auto"
    [placeholder]="placeholder"
    [required]="required"
    [readonly]="readonly"
    [class.has-tooltip]="tooltip !== ''"
    />
    @if (frmCtrl?.enabled && tooltip !== '') {
      <i class="fal fa-question-circle ignite-field-tooltip" ignitetooltip="{{ tooltip }}"></i>
    }
    @if (frmCtrl?.enabled && hint !== '') {
      <mat-hint>{{ hint }}</mat-hint>
    }
    @if (frmCtrl?.hasError('required')) {
      <mat-error i18n>{{ label }} is required</mat-error>
    }
    @if (frmCtrl?.hasError('unmatchedItem')) {
      <mat-error i18n>{{ label }} is invalid</mat-error>
    }
    <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption="true" [displayWith]="showValue">
      @for (option of filteredOptions$ | async; track option) {
        <mat-option [value]="option">
          {{ option.text }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
